import { TagCategory } from '@exam-center/graphql';
import { type TableHeaderRow } from '@shared/table-generator';

function getScoreSectionTitle(tagCategory: TagCategory | null) {
  if (tagCategory === TagCategory.Part) return 'คะแนนรายหมวด';
  if (tagCategory === TagCategory.Subject) return 'คะแนนรายวิชา';

  return 'คะแนน';
}

interface OrderedScoreColumn {
  id: string;
  label: string;
}

export function getColumns(
  orderedScoreColumns: OrderedScoreColumn[],
  tagCategory: TagCategory | null,
) {
  const scoreSectionTitle = getScoreSectionTitle(tagCategory);

  const scoreColumns = orderedScoreColumns.map((column) => ({
    id: `exam-event-score-report-tag-${column.id}`,
    children: column.label,
    align: 'center' as const,
    sx: {
      width: '80px',
      fontSize: '16px',
      px: '12px',
      py: '10px',
    },
  }));

  return [
    {
      children: [
        {
          id: 'exam-event-score-report-seat-number',
          children: 'No.',
          align: 'center',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '80px',
            minWidth: '80px',
            fontSize: '16px',
            px: '12px',
            py: '10px',
          },
        },
        {
          id: 'exam-event-score-report-full-name',
          children: 'ชื่อ-นามสกุล',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '240px',
            minWidth: '240px',
            fontSize: '16px',
            px: '12px',
            py: '10px',
          },
        },
        {
          id: 'exam-event-score-report-id-number',
          children: 'ID / Passport No.',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '180px',
            fontSize: '16px',
            px: '12px',
            py: '10px',
          },
        },
        {
          id: 'exam-event-score-report-course',
          children: 'หลักสูตร',
          align: 'center',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '100px',
            minWidth: '100px',
            fontSize: '16px',
            px: '12px',
            py: '10px',
          },
        },
        ...(scoreColumns.length > 0
          ? [
              {
                id: 'exam-event-score-report-score-group',
                children: scoreSectionTitle,
                align: 'center' as const,
                colSpan: scoreColumns.length,
                sx: {
                  width: `${scoreColumns.length * 80}px`,
                  fontSize: '16px',
                  px: '12px',
                  py: '10px',
                },
              },
            ]
          : []),
        {
          id: 'exam-event-score-report-total-score',
          children: 'คะแนนรวม',
          align: 'center',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '100px',
            fontSize: '16px',
            px: '10px',
            py: '10px',
          },
        },
        {
          id: 'exam-event-score-report-result',
          children: 'ผลสอบ',
          align: 'center',
          rowSpan: scoreColumns.length > 0 ? 2 : 1,
          sx: {
            width: '100px',
            fontSize: '16px',
            px: '12px',
            py: '10px',
          },
        },
      ],
    },
    ...(scoreColumns.length > 0
      ? [
          {
            children: scoreColumns,
          },
        ]
      : []),
  ] as TableHeaderRow[];
}
